.tooltipContent {
  width: max-content;
  max-width: min(18rem, calc(100vw - 20px));
  max-height: var(--popover-available-height, calc(100dvh - 20px));
  overflow: auto;
  overflow-wrap: anywhere;
  padding: 0.375rem 0.5rem;
  border: 1px solid color-mix(in srgb, var(--color-foreground) 18%, transparent);
  border-radius: 0.375rem;
  background: var(--color-foreground);
  color: var(--color-background);
  box-shadow: 0 0.25rem 0.75rem rgb(15 17 23 / 0.16);
  font-size: 0.75rem;
  font-weight: 500;
  line-height: 1.35;
  white-space: normal;
  user-select: text;
}
